<template>
  <el-main class="common-main">
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>确认订单</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="order-box">
        <div class="order-title">
          订单商品
        </div>
        <div class="order-list">
          <div class="order-item order-list-header">
            <el-row :gutter="24">
              <el-col :span="4">
                图片
              </el-col>
              <el-col :span="10">
                课程
              </el-col>
              <el-col :span="6">
                科目
              </el-col>
              <el-col :span="4">
                价格
              </el-col>
            </el-row>
          </div>
          <div class="order-item" v-for="(item, index) in orders" :key="index" v-if="item.study">
            <el-row :gutter="24">
              <el-col :span="4">
                <img :src="item.study.images && item.study.images.length > 0 ? path + item.study.images[0] : noneImg"
                     :alt="item.study.title" class="cart-item-img">
              </el-col>
              <el-col :span="10">
                <router-link :to="{path: '/course/'+item.study.id}" class="cart-item-title">
                  {{ item.study.title }}
                </router-link>
              </el-col>
              <el-col :span="6">
                <div class="cart-item-title">{{ item.course.title }}</div>
              </el-col>
              <el-col :span="4">
                <div class="cart-item-price">¥ {{ item.study.o_price }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="container coupon">
      <div class="order-box">
        <div class="order-title">
          使用优惠码
        </div>
        <div class="order-body">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-input v-model="code" placeholder="输入优惠码" :disabled="codeInfo ? true : false"></el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="success" @click="checkCode" v-if="!codeInfo">校验</el-button>
              <el-button type="danger" @click="cancelCode" v-if="codeInfo">取消</el-button>
            </el-col>
          </el-row>
          <p class="code-title" v-if="codeInfo">{{ codeInfo.description }}</p>
          <div class="order-code-intro">
            注：使用优惠码下单前，请先校验优惠码是否有效！
          </div>
        </div>
      </div>
    </div>
    <div class="container pay">
      <div class="order-box">
        <div class="order-title">
          选择支付方式
        </div>
        <div class="order-body">
          <div class="order-pay-box">
            <el-radio v-model="pay" label="0" border>在线支付</el-radio>
            <el-radio v-model="pay" label="1" border>银行汇款</el-radio>
          </div>
          <div class="order-pay-bank" v-if="pay === '1'">
            注：仅支持下单完成后进行线下转账，转账完成后请联系老师或者客服确认此订单！
          </div>
        </div>
      </div>
    </div>
    <div class="container confirm">
      <div class="confirm-box">
        <div class="confirm-price">
          <span>订单金额：</span>
          <span class="confirm-price-number">¥{{ price }}</span>
        </div>
        <div class="confirm-button">
          <el-button type="primary" @click="confirmOrder">提交订单</el-button>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import ls from "@/utils/localStorage"
import {authRequest} from "@/utils/request";

export default {
  name: "orderIndex",
  head() {
    return {
      title: '确认订单'
    }
  },
  data() {
    return {
      orders: [],
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      code: '',
      pay: '',
      price: '',
      codeInfo: ''
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    getResult() {
      this.orders = ls.getItem('order')
      let price = 0
      this.orders.forEach((item, index) => {
        price += parseFloat(item.study.o_price)
      })
      this.price = price
    },
    async confirmOrder() {
      if (!this.pay) {
        this.$message.error('请选择支付方式')
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '订单提交中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        let response = await authRequest('order', {
          method: 'POST',
          data: {
            data: this.orders,
            type: this.pay,
            coupon_code: this.code
          }
        })
        if (response.status === 201) {
          loading.close()
          this.$router.replace({path: '/pay/' + response.data.id})
        }
      } catch (e) {
        loading.close()
      }
    },
    async checkCode() {
      if (!this.code) {
        this.$message.warning('请输入优惠券码')
        return false
      }
      try {
        let response = await authRequest('coupon_codes/' + this.code, {
          method: 'GET'
        })
        console.log(response)
        this.codeInfo = response.data
      } catch (e) {

      }
    },
    cancelCode() {
      this.code = ''
      this.codeInfo = ''
    }
  }
}
</script>

<style scoped>
.order-box {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
}

.order-title {
  border-left: 3px solid #2aacb2;
  line-height: 45px;
  padding-left: 12px;
  border-bottom: 1px solid #ebebeb;
}

.order-list {
  padding: 0 15px;
}

.order-list-header {
  font-weight: 500;
}

.order-item {
  border-bottom: 1px dashed #ebebeb;
  padding: 20px 0;
  font-size: 14px;
}

.order-item:last-child {
  border-bottom: 0;
}

.cart-item-img {
  width: 150px;
  height: 82px;
  object-fit: cover;
  border-radius: 5px;
}

.cart-item-price {
  color: #f44848;
  font-size: 18px;
}

.coupon {
  margin-top: 20px;
}

.pay {
  margin-top: 20px;
}

.order-body {
  padding: 15px;
}

.order-code-intro {
  margin-top: 10px;
  color: #999999;
  font-size: 12px;
}

.order-pay-bank {
  margin-top: 10px;
  color: #999999;
  font-size: 12px;
}

.confirm {
  margin-top: 20px;
}

.confirm-box {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.confirm-price-number {
  color: #f44848;
  font-size: 20px;
}

.code-title{
  text-align: left;
}
</style>